import React from 'react';

const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: true,
    });
};

const DateShow = ({ date }) => {
    if (!date) return null;

    return <span>{formatDate(date)}</span>;
};

export default DateShow;

// import React from 'react';
// const formatDate = (dateString) => {
//     // Ensure dateString is valid before formatting
//     const date = new Date(dateString);
//     if (isNaN(date)) {
//         return 'Invalid Date'; // Or return some fallback value
//     }
//     return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
// };

// const DateShow = ({ date }) => {
//     if (!date) return null;

//     return <span>{formatDate(date)}</span>;
// };

// export default DateShow;
